import axios from '../../axios'
import Axios, { AxiosRequestConfig } from 'axios'
import { action, makeObservable, observable, runInAction } from 'mobx'
import { toast } from 'react-toastify'
import { User } from './types'
import history from 'history.js'
export class UsersStore {
  loadingList: boolean = false
  deleting: boolean = false
  list: User[] = []
  entries: {
    [key: string]: User
  } = {}
  totalPages: number = 0
  totalElements: number = 0
  cancelTokenSource = () => {}

  constructor() {
    makeObservable(this, {
      loadingList: observable,
      deleting: observable,
      list: observable,
      entries: observable,
      totalPages: observable,
      totalElements: observable,
      getData: action,
      // delete: action,
      setUser: action,
      reset: action,
      clearList: action,
      removeFromList: action,
      setLoadingList: action,
    })
  }

  reset = () => {
    this.clearList()
    this.deleting = false
    this.entries = {}
    this.cancelTokenSource = () => {}
  }

  clearList = () => {
    this.loadingList = false
    this.list = []
    this.totalPages = 0
    this.totalElements = 0
  }

  setLoadingList = (value: boolean) => {
    this.loadingList = value
  }

  removeFromList = (id: number) => {
    this.list = this.list.filter((item) => item.id !== id)
  }

  create = async (data: object) => {
    return await axios
      .post('/management/api/v1/user', data)
      .then((response) => {
        toast.success('Created successfully')
        return response
      })
  }

  update = async (id: number, data: object) => {
    return await axios
      .put('/management/api/v1/user/' + id, data)
      .then((response) => {
        toast.success('Updated successfully')
        return response
      })
  }

  // delete = async (id: number) => {
  //   this.deleting = true
  //   await axios
  //     .delete('/management/api/v1/user/' + id)
  //     .then(({ data }) => {
  //       toast.success('Deleted successfully')
  //       this.removeFromList(id)
  //     })
  //     .finally(() => {
  //       this.deleting = false
  //     })
  // }

  getById = async (id: number) => {
    return await axios(`/management/api/v1/user/${id}`).then(({ data }) => {
      this.setUser(data)
      return data
    })
  }

  getData = (filters: any = {}) => {
    if (typeof this.cancelTokenSource == 'function') {
      // this.cancelTokenSource()
    }
    const cancelTokenSource = Axios.CancelToken.source()

    const params: any = {
      ...filters,
      criteria: filters.searchValue,
      includeEnterprise: true,
      includeGroups: true,
      includeRoles: true,
    }
    delete params.searchValue

    this.setLoadingList(true)

    const config: AxiosRequestConfig = {
      cancelToken: cancelTokenSource.token,
      params,
    }
    axios
      .get(`/management/api/v1/user`, config)
      .then(({ data }) => {
        if (data?.content) {
          runInAction(() => {
            this.list = data.content
            this.totalPages = data.totalPages
            this.totalElements = data.totalElements
            this.list.forEach((item) => (this.entries[`${item.id}`] = item))
          })
        }
      })
      .catch(() => {
        this.clearList()
      })
      .finally(() => {
        this.setLoadingList(false)
      })

    this.cancelTokenSource = cancelTokenSource.cancel
  }

  setUser = (user: User) => {
    const index = this.list.findIndex((item: User) => item.id === user.id)
    if (index !== -1) {
      this.list[index] = user
    }
    this.entries[`${user.id}`] = user
  }

  searchUsers = async (searchValue: string, cancelTokenSource?: any) => {
    const { data } = await axios.get(
      `/management/api/v1/user?criteria=${encodeURIComponent(
        searchValue
      )}&size=${5}`,
      {
        // @ts-ignore
        cancelTokenSource,
      }
    )
    return data.content
  }

  findUsersInCurrentUserGroups = async (searchValue: string) => {
    return await axios(
      `/api/v1/user/group/member?userEmail=${encodeURIComponent(searchValue)}`
    ).then(({ data }) => data)
  }

  findUsersInCurrentUserGroupsWithName = async (searchValue: string) => {
    return await axios(
      `/api/v1/user/group/member?userName=${encodeURIComponent(searchValue)}`
    ).then(({ data }) => data)
  }

  updateUserGroups = async (
    id: number,
    data: { newGroups: number[]; removedGroups: number[] }
  ) => {
    return await axios
      .put(`/management/api/v1/user/${id}/group`, data)
      .then((response) => {
        toast.success('Groups updated successfully')
        return response
      })
  }
  updateUserRoles = async (
    id: number,
    data: { newRoles: number[]; removedRoles: number[] }
  ) => {
    return await axios
      .put(`/management/api/v1/user/${id}/role`, data)
      .then((response) => {
        toast.success('Roles updated successfully')
        return response
      })
  }

  enableUser = async (id: number) => {
    return await axios
      .put(`/management/api/v1/user/${id}/enable`)
      .then((response) => {
        toast.success('User enabled successfully')
        const index = this.list.findIndex((item: User) => item.id === id)
        if (index !== -1) {
          this.list[index] = { ...this.list[index], disabled: false }
        }
        return response
      })
  }

  resetMfa = async (id: number) => {
    return await axios.put(`/management/api/v1/user/${id}/mfa-preference-sms`).then((response) => {
      toast.success('MFA prefrence updated successfully')
      return response
    })
  }

  disableUser = async (id: number) => {
    return await axios
      .put(`/management/api/v1/user/${id}/disable`)
      .then((response) => {
        toast.success('User disabled successfully')
        const index = this.list.findIndex((item: User) => item.id === id)
        if (index !== -1) {
          this.list[index] = { ...this.list[index], disabled: true }
        }
        return response
      })
  }

  // This method is used to reset the password of new user whos password has expired before he do the first sign-in
  resetNewAccountPassword = async (email: string) => {
    let data = {
      userEmail: email,
      resetPasswordOfNewAccount: true,
    }
    return await axios
      .put(`/management/api/v1/user/password`, data)
      .then((response) => {
        if (response.status === 200) {
          toast.success('Reset password sent successfully')
        } else {
          toast.error('Reset password not sent')
        }
        return response
      })
  }
}

export const usersStore = new UsersStore()
